import React from "react";
import Carousel from "react-bootstrap/Carousel";

const CarouselComponent = ({ handleSelect, defActive, onSlideFunction, carouselItems }) => {
  const renderHighlightedLine = (line, highlights = []) => {
    if (!highlights.length) return <span>{line}</span>;

    const regex = new RegExp(`(${highlights.join("|")})`, "gi");
    const parts = line.split(regex);

    return parts.map((part, i) =>
      highlights.some((h) => h.toLowerCase() === part.toLowerCase()) ? (
        <span key={i} className="highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <Carousel
      indicators={false}
      onSelect={handleSelect}
      activeIndex={defActive}
      pause={false}
      interval={5000}
      prevIcon={null}
      nextIcon={null}
      onSlide={onSlideFunction}
    >
      {carouselItems.map((item) => (
        <Carousel.Item key={item.id}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-12 text-center">
                <div className="detail-box">
                  {item.lines.map((line, index) => (
                    <h1 key={index} className="carousel-line">
                      {renderHighlightedLine(line, item.highlights)}
                    </h1>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default CarouselComponent;
